import React, { Component } from 'react';
import { Styles } from './styles/banner.js';

export default class Banner extends Component {
    render() {
        return (
            <Styles>
                <section className="bitHeader-area" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/${this.props.image})` }}>
                    <div className="container-xl">
                        <hr /><h2 className="title">{this.props.title}</h2>
                    </div>
                </section>
                <div className="progress" style={{ height: "0.3rem" }}><div className="progress-bar bg-warning" role="progressbar" style={{ width: "100%" }}></div></div>
            </Styles>
        )
    }
}
